var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',{attrs:{"size":"17"}},[_vm._v("mdi-trash-can-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }